import './Spinner.css';

const Spinner = ({width = 30, height = 30}) => {
    return <div className="loader spinner" style={{width: width, height: height, margin: 'auto'}}></div>;
};

export default Spinner;